import { createAction, handleActions } from 'redux-actions';

/**
 * type
 */
const INITIALIZE_PORTAL = 'portal/INITIALIZE_PORTAL';
const CHANGE_PORTAL = 'portal/CHANGE_PORTAL';
const SET_PORTAL = 'portal/SET_PORTAL';
const DEL_PORTAL = 'portal/DEL_PORTAL';

/**
 * action
 */
export const initializePortal = createAction(INITIALIZE_PORTAL);
export const changePortal = createAction(CHANGE_PORTAL, (urls) => urls);
export const setPortal = createAction(SET_PORTAL, (url) => url);
export const delPortal = createAction(DEL_PORTAL, (url) => url);

/**
 * adcode 모듈 store 초기값
 */
const initialState = {
  cnt: 0,
  portal: [],
};

/**
 * reducer
 */
const portal = handleActions(
  {
    [INITIALIZE_PORTAL]: () => {
      return initialState;
    },
    [SET_PORTAL]: (state, { payload }) => {
      return {
        ...state,
        portal: payload,
      };
    },
    [DEL_PORTAL]: (state, { payload }) => {
      return {
        ...state,
        portal: payload,
      };
    },
  },
  initialState
);

export default portal;
